<template>
  <div v-if="isOpen" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-icon">
          <img
            :src="
              icon == 'info'
                ? require('@/assets/img/info-icon.png')
                : require('@/assets/img/success-icon.png')
            "
          />
        </div>
        <div class="modal-title" style="text-align: center">
          {{ title }}
        </div>
      </div>
      <div class="modal-content">
        <p style="text-align: center" v-html="description"></p>
      </div>
      <div class="modal-footer">
        <v-btn color="grey" @click="close">{{ button1Text }}</v-btn>
        <v-btn color="primary" @click="close" :href="button2Link">
          {{ button2Text }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notificationSystem",
  data() {
    return {
      isOpen: false,
      icon: "",
      title: "",
      description: "",
      button1Text: "Cancel",
      button1Link: null,
      button2Text: "Ok",
      button2Link: null,
    };
  },
  methods: {
    open({
      icon = "info",
      title = "",
      description = "",
      button1Text = this.$t("close"),
      button1Link = null,
      button2Text = this.$t("ok"),
      button2Link = null,
    }) {
      this.icon = icon;
      this.title = title;
      this.description = description;
      this.button1Text = button1Text;
      this.button1Link = button1Link;
      this.button2Text = button2Text;
      this.button2Link = button2Link;

      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.modal-icon {
  margin-right: 10px;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

button {
  padding: 8px 16px;
  cursor: pointer;
}

.v-btn {
  text-transform: capitalize;
}
</style>
